var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2076_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6C9.75 5.58579 9.41421 5.25 9 5.25C8.58579 5.25 8.25 5.58579 8.25 6H9.75ZM11.25 10.5C11.6642 10.5 12 10.1642 12 9.75C12 9.33579 11.6642 9 11.25 9V10.5ZM1.78148 1.85185C1.45803 2.11061 1.40559 2.58257 1.66435 2.90602C1.92311 3.22947 2.39507 3.28191 2.71852 3.02315L1.78148 1.85185ZM4.59352 1.52315C4.91697 1.26439 4.96941 0.792425 4.71065 0.468979C4.45189 0.145532 3.97993 0.0930912 3.65648 0.351848L4.59352 1.52315ZM15.2815 3.02315C15.6049 3.28191 16.0769 3.22947 16.3357 2.90602C16.5944 2.58257 16.542 2.11061 16.2185 1.85185L15.2815 3.02315ZM14.3435 0.351848C14.0201 0.0930912 13.5481 0.145532 13.2893 0.468979C13.0306 0.792425 13.083 1.26439 13.4065 1.52315L14.3435 0.351848ZM8.25 6L8.25 8.625H9.75L9.75 6H8.25ZM15.75 9C15.75 12.7279 12.7279 15.75 9 15.75V17.25C13.5563 17.25 17.25 13.5563 17.25 9H15.75ZM9 15.75C5.27208 15.75 2.25 12.7279 2.25 9H0.75C0.75 13.5563 4.44365 17.25 9 17.25V15.75ZM2.25 9C2.25 5.27208 5.27208 2.25 9 2.25V0.75C4.44365 0.75 0.75 4.44365 0.75 9H2.25ZM9 2.25C12.7279 2.25 15.75 5.27208 15.75 9H17.25C17.25 4.44365 13.5563 0.75 9 0.75V2.25ZM2.71852 3.02315L4.59352 1.52315L3.65648 0.351848L1.78148 1.85185L2.71852 3.02315ZM16.2185 1.85185L14.3435 0.351848L13.4065 1.52315L15.2815 3.02315L16.2185 1.85185ZM10.125 10.5H11.25V9H10.125V10.5ZM8.25 8.625C8.25 9.66053 9.08947 10.5 10.125 10.5V9C9.91789 9 9.75 8.83211 9.75 8.625H8.25Z",
    fill: "#5F6462"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2076_685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.360d86c8f82c2b3335d9c549d3ea65fe.svg";
export { ForwardRef as ReactComponent };